import React, { useEffect, useRef, useState } from 'react'

const SettingsDropdwon = ({ 
  trigger, 
  options = [], 
  className = '',
  dropdownClassName = '',
  position = 'bottom-right'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleOptionClick = (option) => {
    if (option.onClick) {
      option.onClick();
    }
    if (!option.keepOpen) {
      setIsOpen(false);
    }
  };

  const getPositionClasses = () => {
    switch (position) {
      case 'bottom-right':
        return 'top-full right-0 mt-0.5';
      case 'top-left':
        return 'bottom-full left-0 mb-0.5';
      case 'top-right':
        return 'bottom-full right-0 mb-0.5';
      case 'bottom-left':
      default:
        return 'top-full left-0 mt-0.5';
    }
  };

  return (
    <div ref={dropdownRef} className={`relative inline-block ${className}`}>

      <div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer">
        {trigger}
      </div>

      {isOpen && (
        <div 
          className={`absolute ${getPositionClasses()} z-50 min-w-[120px] rounded-lg bg-white shadow-lg border border-gray-200 py-1 ${dropdownClassName}`}
        >
          {options.map((option, index) => {
            if (option.separator) {
              return (
                <div key={index} className="my-1 border-t border-gray-200" />
              );
            }

            const isDisabled = option.disabled;
            
            return (
              <button
                key={index}
                onClick={() => !isDisabled && handleOptionClick(option)}
                disabled={isDisabled}
                className={`
                  w-full text-left px-4 py-2 text-sm
                  flex items-center gap-3
                  transition-colors duration-150
                  ${isDisabled 
                    ? 'text-gray-400 cursor-not-allowed' 
                    : 'text-gray-700 hover:bg-gray-100 cursor-pointer'
                  }
                  ${option.danger ? 'hover:bg-red-50 hover:text-red-600' : ''}
                  ${option.className || ''}
                `}
              >
                {option.icon && (
                  <span className="text-lg">{option.icon}</span>
                )}
                <span className="flex-1">{option.label}</span>
                {option.badge && (
                  <span className="px-2 py-0.5 text-xs bg-blue-100 text-blue-700 rounded-full">
                    {option.badge}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SettingsDropdwon